import { defineStore } from 'pinia';

export const piniaModalStore = defineStore('modal', {
  state: () => ({
    modal: false 
  }),
  actions: {
    setModalData(data: boolean) {
      this.modal = data;
    }
  }
});
